import {LoginBySms} from "./login-by-sms/login-by-sms";

let evEmitter = require('./../modules/events');
import Trackers from './tracker/tracker';
const trackers = new Trackers();
import Preload from '../modules/preloader';

jQuery(function($) {
    /**
     * Добавляет товар в избранное, необходимо передавать data-аттрибут product-id с ИД товара
     */
    $('body').on('click', '.js-add-favorite', function(e) {
        let preload = new Preload();
        preload.show();

        var $selectorFavorite = $(this);
        let priceVal = 0;

        e.preventDefault();
        $.ajax({
            url: '/ajax/action/favorite/add/',
            data: 'PRODUCT_ID=' + $(this).data('product-id'),
            success: function(result) {
                //Закрашиваем сердечки
                if (result.code === 200) {
                    //Для списка товаров
                    if ($selectorFavorite.hasClass('heart') && $selectorFavorite.hasClass('product__fav')) {
                        $selectorFavorite.addClass('heart--active');
                        $selectorFavorite.addClass('product__fav--active');
                        $selectorFavorite.addClass('js-remove-favorite');
                        $selectorFavorite.removeClass('js-add-favorite');

                        let productCart = $selectorFavorite.parent();
                        priceVal = parseInt($(productCart).find('.product__price-value').attr('data-price').replace(' ', ''));
                    } else {
                        //Для карточки товара
                        $('span.heart').addClass('heart--active');
                        $('span.heart').addClass('js-remove-favorite');
                        $('span.heart').removeClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').removeClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').addClass('js-remove-favorite');

                        $('.product-detail__info span.product-card__fav').removeClass('js-add-favorite');
                        $('.product-detail__info span.product-card__fav').addClass('js-remove-favorite');

                        priceVal = parseInt($('.product-detail__info').find('.product-detail__price-sum').attr('data-price').replace(' ', ''));
                    }
                    if(priceVal > 0){
                        trackers.onAddToFav({
                            fbpixel: {
                                value: parseInt(priceVal)
                            }
                        });
                    }

                    let list = document.getElementsByClassName('breadcrumbs__text');

                    if(!!list.length > 0){
                        trackers.onPMbtnFavorite({param:Array.from(list).slice(-1)[0].innerHTML});
                    }

                    evEmitter.emitEvent('addToFavorites');
                } else if (result.code === 403) {
                    //Показываем окно авторизации
                    LoginBySms.showPopup();
                }

                preload.hide();
            }
        });
    });

    /**
     * Убирает товар из избранного, необходимо передавать data-аттрибут product-id с ИД товара
     */
    $('body').on('click', '.js-remove-favorite', function(e) {
        let preload = new Preload();
        preload.show();

        var $selectorFavorite = $(this);
        e.preventDefault();
        $.ajax({
            url: '/ajax/action/favorite/remove/',
            data: 'PRODUCT_ID=' + $(this).data('product-id'),
            success: function(result) {
                //Закрашиваем сердечки
                if (result.code === 200) {
                    //Для списка товаров
                    if (
                        $selectorFavorite.hasClass('heart--active') &&
                        $selectorFavorite.hasClass('product__fav--active')
                    ) {
                        $selectorFavorite.removeClass('heart--active');
                        $selectorFavorite.removeClass('product__fav--active');
                        $selectorFavorite.removeClass('js-remove-favorite');
                        $selectorFavorite.addClass('js-add-favorite');
                    } else {
                        //Для карточки товара
                        $('span.heart').removeClass('heart--active');
                        $('span.heart').removeClass('js-remove-favorite');
                        $('span.heart').addClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').addClass('js-add-favorite');
                        $('.product-card__top span.product-card__fav').removeClass('js-remove-favorite');

                        $('.product-detail__info span.product-card__fav').addClass('js-add-favorite');
                        $('.product-detail__info span.product-card__fav').removeClass('js-remove-favorite');
                    }
                }

                preload.hide();
            }
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/heart.js